// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PopupContainer from '../PopupContainer';
import CreateChangeRequestPopupForm from './CreateChangeRequestPopupForm';
import * as gatewayActions from '../../actions/gateways';
import * as selectors from '../../reducers';
import type { GATEWAY_FETCH_SUCCESS_TYPE } from '../../types/gateways';

type CreateChangeStopRequestPopupContentProTypes = {
  gateways: Array<GATEWAY_FETCH_SUCCESS_TYPE>,
  startFetchingGateways: Function,
  schoolId: number
}

class CreateChangeStopRequestPopupContent
  extends Component<CreateChangeStopRequestPopupContentProTypes> {
  componentWillMount() {
    const { startFetchingGateways, schoolId } = this.props;
    startFetchingGateways(schoolId);
  }

  render() {
    const { gateways } = this.props;
    return (
      <PopupContainer size="medium">
        <CreateChangeRequestPopupForm gateways={gateways} />
      </PopupContainer>
    );
  }
}
export default connect(
  (state) => {
    const gateways = selectors.getGatewaysChangeStopAvailable(state);
    const schoolId = (selectors.getProfileOfType(state, 'admin') || {}).school || -1;
    return {
      gateways,
      schoolId,
    };
  },
  dispatch => ({
    startFetchingGateways: (schoolId: number) => dispatch(
      gatewayActions.startFetchingGateways(schoolId),
    ),
  }),
)(CreateChangeStopRequestPopupContent);



// WEBPACK FOOTER //
// ./src/scripts/components/CreateChangeStopRequestPopupContent/index.jsx